export default function uniqueArray(value, index, self) {
  return self.indexOf(value) === index;
}
